import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CalendarCheck, Send } from 'lucide-react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';

// Envoi de rentrée (mi-mars) : toute une session, seulement les stagiaires qui n'ont jamais reçu le règlement
export const EnvoiSession = ({ data, onEnvoye }) => {
  const [session, setSession] = useState(data.sessions[0] || '');
  const [confirmer, setConfirmer] = useState(false);
  const n = data.stagiaires.filter((s) => s.session === session && s.statut === 'non_envoye').length;

  const envoyer = async () => {
    try {
      const { data: d } = await axios.post('/reglement-interieur/envoyer-session', { session });
      toast.success(`Session ${session} : règlement envoyé à ${d.envoyes} stagiaire${d.envoyes > 1 ? 's' : ''} (e-mail + notification)`);
      if (d.sans_email?.length) toast.warning(`Sans e-mail (notification seulement) : ${d.sans_email.join(', ')}`);
      onEnvoye();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Envoi impossible');
    }
  };

  if (!data.sessions.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-xl border-2 border-orange-200 bg-white p-4" data-testid="reglement-envoi-session">
      <CalendarCheck className="h-6 w-6 shrink-0 text-orange-500" />
      <div className="min-w-[200px] flex-1">
        <p className="font-semibold text-[#0F172A]">Envoi de rentrée</p>
        <p className="text-xs text-slate-500">Envoie le règlement aux stagiaires de la session qui ne l'ont jamais reçu ({n} pour la session {session}).</p>
      </div>
      <select value={session} onChange={(e) => setSession(e.target.value)} className="rounded-md border border-slate-200 bg-white px-3 py-2 text-sm" data-testid="reglement-envoi-session-choix">
        {data.sessions.map((s) => <option key={s} value={s}>Session {s}</option>)}
      </select>
      <button type="button" disabled={!n} onClick={() => setConfirmer(true)} data-testid="reglement-envoi-session-btn"
        className="inline-flex items-center gap-2 rounded-full bg-orange-500 px-5 py-2 text-sm font-bold text-white shadow transition-colors hover:bg-orange-600 disabled:opacity-40">
        <Send className="h-4 w-4" /> Envoyer à toute la session {session} ({n})
      </button>
      <AlertDialog open={confirmer} onOpenChange={setConfirmer}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Envoyer le règlement à la session {session} ?</AlertDialogTitle>
            <AlertDialogDescription>{n} stagiaire{n > 1 ? 's' : ''} qui ne l'{n > 1 ? 'ont' : 'a'} jamais reçu {n > 1 ? 'recevront' : 'recevra'} un e-mail et une notification. Relance automatique à J+7 si le règlement n'est pas signé.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="reglement-envoi-session-annuler">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={envoyer} data-testid="reglement-envoi-session-confirmer">Envoyer</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
